export const DECRYPT_CONTAINER = 'DECRYPT_CONTAINER'
export const DECRYPT_CONTAINER_SUCCESS = 'DECRYPT_CONTAINER_SUCCESS'
export const DECRYPT_CONTAINER_FAILURE = 'DECRYPT_CONTAINER_FAILURE'

export const decryptContainer = payload => ({type: DECRYPT_CONTAINER, payload})
export const decryptContainerSuccess = payload => ({type: DECRYPT_CONTAINER_SUCCESS, payload})
export const decryptContainerFailure = () => ({type: DECRYPT_CONTAINER_FAILURE})
